// import { Client } from '../clientFlowtypes'

interface State {
  data: {[key: string]: never}; // do the typing later
}

const studyCasesModule = {
  firestorePath: 'studies/{studyId}/cases',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'studyCases',
  statePropName: 'data',
  namespaced: true, // automatically added
  serverChange: {
    convertTimestamps: {
      dbUpdatedAt: '%convertTimestamp%', // default
      dbCreatedAt: '%convertTimestamp%', // default
      attachedDate: '%convertTimestamp%', // default
      consentGivenAt: '%convertTimestamp%',
      consentDeclinedAt: '%convertTimestamp%',
      consentRevokedAt: '%convertTimestamp%',
    },
  },

  // this object is your store module (will be added as '/studies')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    all: (state: State) => state.data,
    getById: (state: State) => (id: string) => state.data[id],
  },
  mutations: {},
  actions: {
  },
}

export default studyCasesModule
